import LoadingSplash from "../../../lib/components/LoadingSplash";

export default function SuspenseFallbackComponent({
  className = "w-full h-full",
  scaleClass = null,
}) {
  return <LoadingSplash className={className} scaleClass={scaleClass} />;
}
